import { api, type ApiResponse } from '@/lib/api';
import type { CommercialDashboardQuery, CommercialDashboardResponse } from '@troia-v3/types';

/**
 * API client for the Commercial Dashboard module.
 *
 * Backend endpoint: GET /api/dashboards/commercial?period=month&year=YYYY&month=MM
 */
export const dashboardsCommercialApi = {
  async get(query: CommercialDashboardQuery): Promise<CommercialDashboardResponse> {
    const response = await api.get<ApiResponse<CommercialDashboardResponse>>(
      'dashboards/commercial',
      { params: query },
    );
    return response.data.data!;
  },
};
